import React from "react";

import { Autocomplete, ListItemText, Stack, TextField, Typography } from "@mui/material";
import { usePickUserPermissions, useUserRoleSelector } from "store";
import { ICryptocurrencyOption, UserPermissionType } from "store/types";
import { isRoleAnalyst } from "utils/user";

interface Props {
  inputValue: string;
  setInputValue: React.Dispatch<React.SetStateAction<string>>;
  selectCrypto: React.Dispatch<React.SetStateAction<{ key: string; value: string } | null>>;
  options: ICryptocurrencyOption[];
  resetData: () => void;
}

export const CryptoSearch: React.FC<Props> = ({ inputValue, setInputValue, options, selectCrypto }) => {
  const role = useUserRoleSelector();
  const myDeals = usePickUserPermissions("deals");
  const noAccessPermission = myDeals && myDeals === UserPermissionType.NO_ACCESS;
  const isViewerPermission = myDeals && myDeals === UserPermissionType.VIEWER;
  return (
    <Stack gap="22px">
      <Typography color="#0A3142" fontSize="16px">
        Enter the cryptocurrency name or symbol below to fetch the latest pricing, market cap, and additional data
        directly through our Crypto API
      </Typography>
      <Autocomplete
        options={options}
        forcePopupIcon={false}
        isOptionEqualToValue={(option, value) => option.value === value.value}
        getOptionLabel={(option) => option.value}
        onInputChange={(_, newInputValue) => {
          setInputValue(newInputValue);
        }}
        onChange={(_, value) => value && selectCrypto(value)}
        renderOption={(props, item) => (
          <li {...props} key={item.key}>
            <ListItemText>{item.value}</ListItemText>
          </li>
        )}
        ListboxProps={{ sx: { ".MuiAutocomplete-option:hover": { backgroundColor: "rgba(219, 232, 245, 1)" } } }}
        inputValue={inputValue}
        disabled={!isRoleAnalyst({ role, preventTV: true, preventUser: noAccessPermission || isViewerPermission })}
        renderInput={(params) => (
          <TextField
            {...params}
            disabled={!isRoleAnalyst({ role, preventTV: true })}
            label="Search Currency"
            variant="outlined"
            InputProps={{
              ...params.InputProps
            }}
          />
        )}
      />
    </Stack>
  );
};
